"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(rawSSN) {
  if (rawSSN.length !== 9 || typeof rawSSN !== 'string') {
    return rawSSN;
  }

  return "".concat(rawSSN.substr(0, 3), "-").concat(rawSSN.substr(3, 2), "-").concat(rawSSN.substr(5));
};

exports.default = _default;